<template>
    <transition name="HotspotEntrance">
        <router-link class="SurfaceHotspot btnfx btnfx__clickflash" v-show="ready" :to="hotspot.route"
            @click.ctrl="showMatrixEditorLink()" :class="[getInactive]" :style="[getStyles, getMatrix]"
            @click="hotspotPressed" >

            <div class="hover-corner topleft"></div>
            <div class="hover-corner topright"></div>
            <div class="hover-corner bottomleft"></div>
            <div class="hover-corner bottomright"></div>

            <span v-if="!hotspot.data.hiddenTitle" :style="[getContinuousHotspotAnimation]" v-html="getHotspotTitle"></span>
            <img v-if="hotspot.data.image" :src="getSrc(hotspot.data.image.src)" :style="[getContinuousHotspotAnimation]" />

        </router-link>
    </transition>
</template>

<script>

export default {


    props: ['hotspot'],
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.renderHotspotCascade();
    },
    methods: {
        renderHotspotCascade() {
            let delay = 0;
            delay = (this.hotspot.index * 200) + 400;

            setTimeout(() => {
                this.ready = true;
            }, delay);
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for randomly timed animations
            return Math.random() * (max - min) + min;
        },
        hotspotPressed() {
            this.$emit('hotspotPressed', this.hotspot)
        },
        showMatrixEditorLink() {
            //show matrix editor link i console
            console.log(this.hotspot.data.matrixEditorLink)
        },
        getSrc(src) {
            return app.api.Utils.getMediaPath(src);
        },
    },
    computed: {
        getStyles() {
            return {
                'font-size': (this.hotspot.data.fontSize>0) ? this.hotspot.data.fontSize + 'px' : '15px',
                'color': (this.hotspot.data.textColor) ? this.hotspot.data.textColor : '#fff'
            }
        },
        getMatrix() {
            return this.hotspot.data.matrix3D;
        },
        getHotspotTitle() {
            return this.hotspot.data.alternateTitle && this.hotspot.data.alternateTitle !== '' ? this.hotspot.data.alternateTitle : this.hotspot.data.title;
        },
        getInactive(){
            let hotspotPrefix = "SurfaceHotspot--"
            if (this.hotspot.data.inactive) {
                return `${hotspotPrefix}inactive`
            } else {
                return
            }
        },
        getContinuousHotspotAnimation() {
            // assign the looping animation on hotspots, as well as keeping them synced with resetHotspot.
            return {
                'animation-name': "hotspotLoopPulse",
                'animation-iteration-count': 'infinite',
                'animation-duration': '15s',
                'animation-delay': this.getRandomAnimationDelay(2, 14).toFixed(1) + 's'
            }
        }

    }
}
</script>


<style lang="scss">
.SurfaceHotspot {
    top: 0;
    left: 0;
    display: flex;
    background: transparent;
    color: #fff;
    position: absolute;
    cursor: pointer;

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        // box-shadow: 0px 0px 2px 2px #f0f inset;


        .hover-corner {
            transform: scale(1);
        }


    }

    &--inactive{
        pointer-events: none!important;
    }


    span {
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: pre-wrap;
        font-weight: bold;
      
        text-transform: uppercase;
        // box-shadow: 0px 0px 2px 2px #f0f inset;
        width: 100%;
        height: 100%;
        // font-size: 15px;
        position: absolute;
        padding: 15px;
        z-index: 3;
    }

    &>img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
    }

    .hover-corner {
        position: absolute;
        border: 2px solid var(--main-color);
        width: 20px;
        height: 20px;
        transform: scale(0);
        transition: transform 0.1s var(--tk-easeinout);


        &.topleft {
            border-right: none;
            border-bottom: none;
            top: -10px;
            left: -10px;
        }

        &.topright {
            border-left: none;
            border-bottom: none;
            top: -10px;
            right: -10px;
        }

        &.bottomleft {
            border-right: none;
            border-top: none;
            bottom: -10px;
            left: -10px;
        }

        &.bottomright {
            border-left: none;
            border-top: none;
            bottom: -10px;
            right: -10px;
        }
    }

}

/* entrance animation */
.HotspotEntrance-enter-active {
    transition: all 1s var(--tk-easeinout);
}

.HotspotEntrance-leave-active {
    transition: all 0.3s var(--tk-easeinout);
}

.HotspotEntrance-enter-from {
    opacity: 0;
}

.HotspotEntrance-leave-to {
    opacity: 0;
}
</style>